import script from "./FaqsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqsSection.vue?vue&type=script&setup=true&lang=js"

import "./FaqsSection.vue?vue&type=style&index=0&id=96f40066&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96f40066"]])

export default __exports__